export const assuranceEn = {
  "Societé": "Sociey",
  "Consultation": "Consultation",
  "Couleur": "Color",
  "Type": "Type",
  "Afficher les Archives": "Show Archived",
  "Facture Global": "Global Invoice",

  // Server side 

  "La societe existe deja!": "The company already exists!",
  "le nom de la societe est obligatoire!": "the name of the company is required!",
  "Prix de la consultation est obligatoire!": "Consultation price is obligatory!",
  "Impossible de supprimer la facture": "Unable to delete invoice",

}